<template lang="pug">
div
  // vcht-banner(v-if="$conf.isVcht")
  .overlay-blur
  .custom-application--wrap
    email-verify-alert
    regional-contacts-dialog
    modals-controller
    // link-profiles-alert
    //- announcement-dialog(
    //-   :type="constants.ANNOUNCEMENT_TYPES.ALL"
    //- )

    ev-navigation-drawer
    v-main
      the-header
      slot
      the-footer

  portal-target(name="afterwrap")
  the-instructions
</template>

<script>
import EmailVerifyAlert from '@/components/dialogs/EmailVerifyAlert.vue';
import EvNavigationDrawer from '@/components/layout/Remaked/EvDrawer.vue';
import TheHeader from '@/components/layout/TheHeader.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import TheInstructions from '@/components/layout/TheInstructions.vue';

// ! @TODO remove, currently used in some places | deprecated
import ModalsController from '@/components/layout/ModalsController/index.vue';
// ! @TODO may be deprecated
import RegionalContactsDialog from '@/components/dialogs/RegionalContactsDialog.vue';
import LinkProfilesAlert from '@/components/dialogs/LinkProfilesAlert.vue';
// ! @TODO may be deprecated | vcht specific
import VchtBanner from '@/components/layout/VchtBanner.vue';
// ! @TODO may be should be used in welcome-dialog for organization vcht | vcht specific
import AnnouncementDialog, { ANNOUNCEMENT_TYPES } from '@/components/dialogs/AnnouncementDialog.vue';

export default {
  components: {
    EvNavigationDrawer,
    TheHeader,
    TheFooter,
    TheInstructions,
    VchtBanner,
    ModalsController,
    EmailVerifyAlert,
    LinkProfilesAlert,
    AnnouncementDialog,
    RegionalContactsDialog,
  },
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        ANNOUNCEMENT_TYPES,
      };
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.custom-application--wrap {
  height: calc(100vh - 40px);
  margin: 20px;
  border-radius: 25px;
  background: #f5f6fbb5;
  overflow: auto;
  z-index: 1;

  @media screen and (max-width: 768px) {
    margin: 0;
    height: 100vh;
    border-radius: 0;
  }
}
.border-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #ecedf9;
}
.overlay-blur {
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
}
.v-main {
  min-height: 100%;

  ::v-deep &__wrap {
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0px;

    @media screen and (max-width: 768px) {
      height: 100%;
      width: calc(100vw - 56px);
      position: fixed;
      overflow: auto;
    }
  }
}
</style>
